import React from 'react';

const ResourceRow = (props) => {
  return (
    <tr>
      <td headers="agency"><h3>{props.name}</h3>
        {props.address}<br />
        {props.city}<br />
        {props.phone}<br />
      </td>
      <td headers="details">{props.details}</td>
      <td headers="other">{props.services}</td>
    </tr> 
  );
}

export default ResourceRow;